import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map } from 'rxjs/operators';
import * as HubActions from 'src/app/root-store/hub-connection-store/hub-connection.actions';
import { HubConnectionService } from 'src/app/shared/services/realtime-connection.service';
import { InvoiceHubMessage } from 'src/app/shared/services/realtime-constants';
import {
    disconnectFromInvoiceProcessingFeed,
    ensureConnectedToInvoiceProcessingFeed,
    InvoiceProcessBatch,
    processInvoiceFailure,
    processInvoiceSuccess
} from '../actions/invoice.actions';

interface ProcessInvoiceSuccess {
    invoiceId: number;
    batch: InvoiceProcessBatch;
}

interface ProcessInvoiceFailure {
    error: string;
    batch: InvoiceProcessBatch;
}

@Injectable()
export class InvoiceEffects {
    constructor(
        private readonly _actions$: Actions,
        private readonly _hubConnectionService: HubConnectionService
    ) {}

    invoiceProcessSuccess$ = createEffect(() => {
        return this._hubConnectionService.invoiceHub
            .messagesOf<ProcessInvoiceSuccess>(InvoiceHubMessage.INVOICE_PROCESS_SUCCESS)
            .pipe(map((event) => processInvoiceSuccess(event)));
    });

    invoiceProcessFailure$ = createEffect(() => {
        return this._hubConnectionService.invoiceHub
            .messagesOf<ProcessInvoiceFailure>(InvoiceHubMessage.INVOICE_PROCESS_FAILURE)
            .pipe(map((error) => processInvoiceFailure(error)));
    });

    connectToSignalR$ = createEffect(() => {
        return this._actions$.pipe(
            ofType(ensureConnectedToInvoiceProcessingFeed),
            map(() => HubActions.connectToInvoiceHub())
        );
    });

    disconnectFromSignalR$ = createEffect(() => {
        return this._actions$.pipe(
            ofType(disconnectFromInvoiceProcessingFeed),
            map(() => HubActions.disconnectFromInvoiceHub())
        );
    });
}
